<template>
  <div class="ajax-form">
    <input type="hidden" name="category" value="1">
    <div class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">Assistance VU - VL</div>
          <div class="page__head-title__notice">(* champs obligatoires)</div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!isSending">
      <div class="col-12">
        <div class="form_ttl" v-if="vehicles.length > 1">Informations sur les {{ vehicles.length }} véhicules à assister
        </div>
        <div class="form_ttl" v-else>Informations sur le véhicule à assister</div>
      </div>

      <div class="col-12" v-for="(vehicle, index) in vehicles" :key="index">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Immatriculation du Véhicule {{ index + 1 }}</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceVUVL['immatriculation' + index]" class="input_n"
              :class="{ input_red_shadow: hasError('immatriculation' + index) }">
          </div>
        </div>
      </div>

      <div class="print-page-break"></div>

      <div class="garantie-view__body__block--content">
        <div class="description">

          <div class="insurance-info">
            <div class="insurance-info__buttons">
              <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                <div class="insurance-info__buttons--wrapper">
                  <router-link :to="/assistance-vu-vl-view/ + $route.params.id" class="blue">
                    Retour
                  </router-link>
                  <div class="ball-anchor blue"></div>
                </div>
              </div>
              <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                <div class="insurance-info__buttons--wrapper">
                  <a href="#" @click.prevent="onSubmit" class="purple">
                    Souscrire à l'assistance
                  </a>
                  <div class="ball-anchor purple"></div>
                </div>
              </div>
              <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                <div class="insurance-info__buttons--wrapper">
                  <router-link v-if="!showRetourButton" :to="'/'" class="black">Fermer
                  </router-link>
                  <router-link v-else :to="'/'" class="black">Fermer</router-link>
                  <div class="ball-anchor black"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-else>
      <Preloader />
    </template>
    <BrokerAssistanceErrorModal v-show="isErrors" @close="closeModal" :data="isErrorMessage" />
    <ValidationErrors :errorsList="errors" />
  </div>
</template>

<script>
import ValidationErrors from '@/components/Garantie/ValidationErrors';
import garantieFieldsLists from '@/mixins/garantieFieldsLists';
import Preloader from '@/components/Preloader'
import { DEBOUNCE } from "@/mixins/helper";
import { TheMask } from 'vue-the-mask'
import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';
import CustomTextInput from "../DealerInsuranceCampingCar/CustomTextInput";
import CustomRadioInput from "../DealerInsuranceCampingCar/CustomRadioInput";
import BrokerAssistanceErrorModal from "./BrokerAssistanceErrorModal";

const INITIAL_FIELDS_VALUES = Object.freeze({});

const CAR_TYPE_VP = 1;
const CAR_TYPE_VU = 2;
const CAR_TYPE_4X4 = 3;

const CIVILITY_M = 0;
const CIVILITY_MLLE = 1;
const CIVILITY_MME = 2;
const CIVILITY_SOCIETY = 3;

export default {
  name: 'BrokerAssistanceVUVLSouscription',
  components: { ValidationErrors, Preloader, TheMask, CustomDatepicker, CustomTextInput, CustomRadioInput, BrokerAssistanceErrorModal },
  mixins: [garantieFieldsLists],
  data() {
    return {
      assistanceVUVL: { ...INITIAL_FIELDS_VALUES },
      vehicles: [],
      errors: {},
      isSending: false,
      searchResult: null,
      isClientSearching: false,
      effectiveDateInput: '',
      shippingDateInput: '',
      circulationDateInput: '',
      birstdayDateInput: '',
      isVehicleSearching: false,
      searchVehicleResult: null,
      acceptedVehicleResult: false,
      pdfWindow: null,
      isErrors: false,
      isErrorMessage: ""
    }
  },
  computed: {
    isEditAssistance() {
      return !!this.$route.params.id
    },
    existingCustomerFound() {
      return !!this.searchResult;
    },
    existingVehicleFound() {
      return !!this.searchVehicleResult;
    },
    // isNewCar() {
    //     return this.assistanceAutocar.is_new === 'Oui';
    // },
    mechanic_id() {
      return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
    },
    getDownloadLink() {
      // alert('getDownloadLink');
      // alert(this.$route.params.id);
      if (this.$route.params.id) {
        // alert('getDownloadLink 288');
        return this.getApiAuthUrl('garantie/generate-assistance-pdf/' + this.$route.params.id);
        // alert('after getDownloadLink 290');
      }

      return '';
    },
  },
  watch: {
    pdfWindow: function () {
      window.location.href = '/merci';
    }
  },
  methods: {
    searchByRegNumber: DEBOUNCE(function (val) {
      this.assistanceVUVL.immatriculation = this.assistanceVUVL.immatriculation.toUpperCase();

      let matched = this.assistanceVUVL.immatriculation.match(/(^([0-9]{2,}-[A-Z]{2,}-[0-9]{2,})+$)|(^([A-Z]{2,}-[0-9]{2,}-[A-Z]{2,})+$)/g);

      if (matched) {
        let url = 'client/registration',
          data = {
            regNumber: this.assistanceVUVL.immatriculation,
            ccar: true
          };
        this.isVehicleSearching = true;
        this.apiPost(url, data, false)
          .then(response => {
            if (response.data.info) {
              this.searchVehicleResult = response.data.info;
            }

            this.isVehicleSearching = false;
          })
          .catch(error => {
            this.showErrorNotification(error);
            this.isVehicleSearching = false;
            this.acceptedVehicleResult = false;
          })
      }
    }, 1000),
    searchClient: DEBOUNCE(function (val) {

      if (this.assistanceVUVL.tel.length > 2) {
        let url = 'client/searchOne',
          data = {
            tel: this.assistanceVUVL.tel
          };
        this.isClientSearching = true;
        this.apiGet(url, data, false)
          .then(response => {
            if (response.data.client) {
              this.searchResult = response.data.client;
            }

            this.isClientSearching = false;
          })
          .catch(error => {
            this.showErrorNotification(error);
            this.isClientSearching = false;
          })
      }
    }, 1000),
    serializeData() {
      this.assistanceVUVL.mechanic_id = this.mechanic_id;

      return this.assistanceVUVL;
    },
    onSubmit(event) {
      let formErrors = {};
      let hasError = false;
      for (let i = 0; i < this.vehicles.length; i++) {
        let key = 'immatriculation' + i;
        if (!this.assistanceVUVL[key] || this.assistanceVUVL[key].trim() === '') {
           formErrors[key] = ["Ce champ est obligatoire."];
           hasError = true;
        }
      }
      if (hasError) {
          this.errors = { errors: formErrors };
          return;
      }

      this.isSending = true;
      let url = 'garantie/assistance-vu-vl',
        data = this.serializeData();
      if (this.isEditAssistance) {
        url = 'garantie/assistance-vehicles-vul/' + this.$route.params.id;
      }
      // alert('beforeUpdate');
      this.apiGet(url, data).then((response) => {
        this.isSending = false;
        this.errors = {};
        // alert('afterUpdate');
        // this.showSuccessNotification(response.data.message, '');
        // let id = response.data.quote.id;
        // this.$router.push('/assistance-autocars-view/' + id);
        // alert(response);
        if (response.data.status === 'success') {
          // alert('success');
          let pdfWindow = window.open(this.getDownloadLink);
          if (pdfWindow) this.pdfWindow = pdfWindow;
        }
        if (response.data.is_old_car == true) {
          this.isErrors = true;
          this.isErrorMessage = response.data.message;
        }
      }).catch(error => {
        this.isSending = false;
        this.errors = error.response.data;

        if (error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
          this.errors.errors = {};
          this.errors.errors.error = [error.response.data.message];
        }
      })
    },
    getGuarantyInfo() {
      let url = `garantie/assistance-details/` + this.$route.params.id,
        data = {
          per_page: 'All'
        };

      this.apiGet(url, data)
        .then(response => {
          this.vehicles = response.data.data;
          this.vehicles.forEach((vehicle, index) => {
            this.$set(this.assistanceVUVL, 'immatriculation' + index, vehicle.immatriculation || "");
          });
        })
        .catch(error => {
          this.showErrorNotification(error);
        })
      // let url = 'garantie/assistance-details/' + this.$route.params.id;
      // this.apiGet(url).then(response => {
      //   this.vehicles = response.details;
      // }).catch(error => {
      //     console.log(error)
      // })
    },
    parseQuoteData(quote) {
      let parsedQuote = {};

      if (quote.details) {
        // if (quote.details.datesParse) {
        //     let effective_day = quote.details.datesParse.day_effective,
        //         effective_month = quote.details.datesParse.month_effective - 1,
        //         effective_year = quote.details.datesParse.year_effective;
        //     parsedQuote.jour_prise_effet = effective_day;
        //     parsedQuote.mois_prise_effet = effective_month;
        //     parsedQuote.annee_prise_effet = effective_year;
        //
        //     this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
        //
        //     parsedQuote.jour_vente = quote.details.datesParse.day_sale;
        //     parsedQuote.mois_vente = quote.details.datesParse.month_sale;
        //     parsedQuote.annee_vente = quote.details.datesParse.year_sale;
        //
        //     parsedQuote.jour_livraison = quote.details.datesParse.day_delivery;
        //     parsedQuote.mois_livraison = quote.details.datesParse.month_delivery;
        //     parsedQuote.annee_livraison = quote.details.datesParse.year_delivery;
        // }

        // alert(quote.effective_date);
        let effective_day = quote.datesParse.day_effective,
          effective_month = quote.datesParse.month_effective - 1,
          effective_year = quote.datesParse.year_effective;
        // alert(effective_day);
        parsedQuote.jour_prise_effet = effective_day;
        // alert(parsedQuote.jour_prise_effet);
        parsedQuote.mois_prise_effet = effective_month;
        parsedQuote.annee_prise_effet = effective_year;

        this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
        if (quote.nb_vehicles_base) {
          parsedQuote.nb_vehicles = quote.nb_vehicles_base;
          parsedQuote.option = 1;
        }
        else if (quote.nb_vehicles_option1) {
          parsedQuote.nb_vehicles = quote.nb_vehicles_option1;
          parsedQuote.option = 2;
        }
        else if (quote.nb_vehicles_option2) {
          parsedQuote.nb_vehicles = quote.nb_vehicles_option2;
          parsedQuote.option = 3;
        }
        else if (quote.nb_vehicles_option3) {
          parsedQuote.nb_vehicles = quote.nb_vehicles_option3;
          parsedQuote.option = 4;
        }
        else if (quote.nb_vehicles_option4) {
          parsedQuote.nb_vehicles = quote.nb_vehicles_option4;
          parsedQuote.option = 5;
        }
        else if (quote.nb_vehicles_option5) {
          parsedQuote.nb_vehicles = quote.nb_vehicles_option5;
          parsedQuote.option = 6;
        }

        parsedQuote.shipping_date = this.moment(quote.details.shipping_date).format('DD/MM/YYYY');
        this.shippingDateInput = new Date(quote.details.shipping_date);
      }
      this.acceptedVehicleResult = true;
      return parsedQuote;
    },

    validateShippingDate() {
      if (!this.shippingDateInput) return false;
      let date = this.moment(this.shippingDateInput).format('DD/MM/YYYY');
      this.assistanceAutocar.shipping_date = date;
      return true;
    },
    resetEffectiveDate() {
      this.assistanceAutocar.jour_prise_effet = 1;
      this.assistanceAutocar.mois_prise_effet = 1;
      this.assistanceAutocar.annee_prise_effet = 1970;
    },
    cleanEffectiveDate() {
      this.assistanceAutocar.jour_prise_effet = '';
      this.assistanceAutocar.mois_prise_effet = '';
      this.assistanceAutocar.annee_prise_effet = '';
    },
    validateCirculationDate() {
      if (!this.circulationDateInput) return false;
      let date = this.moment(this.circulationDateInput);

      this.assistanceAutocar.jour_mise_en_circulation = date.format('D');
      this.assistanceAutocar.mois_mise_en_circulation = date.format('M');
      this.assistanceAutocar.annee_mise_en_circulation = date.format('YYYY');

      return true;
    },
    resetCirculationDate() {
      this.assistanceAutocar.jour_mise_en_circulation = '';
      this.assistanceAutocar.mois_mise_en_circulation = '';
      this.assistanceAutocar.annee_mise_en_circulation = '';
    },
    getListOfDurationOprions() {
      let list = [],
        options = document.getElementById("durationSelect").options;

      for (let option of options) {
        list.push(+option.value);
      }

      return list;

    },
    hasError(field) {
      return !!(this.errors.errors && this.errors.errors[field]);
    },
    closeModal() {
      this.isErrors = false;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.assistanceVUVL = INITIAL_FIELDS_VALUES;
    next();
  },
  mounted() {
    if (this.$route.params.id) this.getGuarantyInfo();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Garantie/BrokerAssistance/BrokerAssistanceVUVLSouscription.vue